import { Activity } from 'lucide-react';
import type { AdminCompanyHealth } from 'app/javascript/types/admin';
import HealthPanel from 'app/javascript/components/admin/company_health/HealthPanel';
import HealthRow from 'app/javascript/components/admin/company_health/HealthRow';
import { formatBRDateTime } from 'app/javascript/utils/dates';

export default function EngagementPanel({ company }: { company: AdminCompanyHealth }) {
  const { members, activity } = company;
  const activeShare = members.total > 0 ? Math.round((members.active_last_30_days / members.total) * 100) : null;

  return (
    <HealthPanel icon={<Activity className="size-4" />} title="Evolução e acompanhamento">
      <div className="grid gap-x-8 sm:grid-cols-2">
        <div>
          <HealthRow label="Tempo desde o cadastro" value={`${company.age_in_days} ${company.age_in_days === 1 ? 'dia' : 'dias'}`} />
          <HealthRow
            label="Membros com presença em 30 dias"
            value={`${members.active_last_30_days}/${members.total}${activeShare === null ? '' : ` · ${activeShare}%`}`}
          />
          <HealthRow label="Membros aceitos nos últimos 30 dias" value={members.joined_last_30_days} />
          <HealthRow label="Membros sem primeiro acesso" value={members.unclaimed} />
        </div>
        <div>
          <HealthRow label="Check-ins nos últimos 7 dias" value={activity.check_ins_last_7_days} />
          <HealthRow label="Check-ins nos 7 dias anteriores" value={activity.check_ins_previous_7_days} />
          <HealthRow
            label="Pedido pendente mais antigo"
            value={members.oldest_pending_at ? formatBRDateTime(members.oldest_pending_at) : 'Nenhum pedido pendente'}
          />
        </div>
      </div>
      <p className="mt-4 max-w-prose text-xs leading-relaxed text-muted-foreground">
        Membros incluem donos e admins. A comparação semanal usa dois períodos de 7 dias, incluindo hoje. Presença mede registros no app; não confirma
        frequência real nem último acesso.
      </p>
      <p className="mt-2 text-xs text-muted-foreground">Dados consultados em {formatBRDateTime(company.snapshot_at)}.</p>
    </HealthPanel>
  );
}
